<template>
    <div class="config-task-dialog" :key="menuKey">
        <div class="config-task-title">
            <h3>任务配置</h3>
        </div>
        <!-- <el-divider></el-divider> -->
        <el-form ref="form" label-width="150px" class="config-task-form" size="small" id="myform">
            <el-divider><strong>任务基本参数</strong></el-divider>
            <el-form-item v-for="(item, index) in taskConfigParam.taskBaseParams" :key="index" :label="paramJugde(index)">
                <el-select v-if="index == 'a_bourse'" disabled v-model="configTaskData.a_bourse" @change="bourseChange('a')">
                    <el-option v-for="(bourse, index) in bourseList.bourse" :key="index" :label="bourse" :value="index"></el-option>
                </el-select>
                <el-select v-else-if="index == 'a_transaction_type' && judgeNumToType(item) !== true" disabled v-model="configTaskData.a_transaction_type" @change="aTransTypeChange">
                    <el-option v-for="(type, index) in abourseType" :key="index" :label="type" :value="index"></el-option>
                </el-select>
                <el-select v-else-if="index == 'a_transaction_type' && judgeNumToType(item) == true" v-model="configTaskData.a_transaction_type" @change="aTransTypeChange">
                    <div v-if="taskConfigParam.taskBaseParams['a_bourse'] == 1">
                        <el-option v-for="(type, index) in okexBourseTransaction" :key="index" :label="addBourseStr(type)" :value="typeValueJudge(type, index)"></el-option>
                    </div>
                    <div v-if="taskConfigParam.taskBaseParams['a_bourse'] == 2">
                        <el-option v-for="(type, index) in huobiBourseTransaction" :key="index" :label="addBourseStr(type)" :value="typeValueJudge(type, index)"></el-option>
                    </div>
                </el-select>
                <el-select v-else-if="index == 'b_bourse'" disabled v-model="configTaskData.b_bourse" @change="bourseChange('b')">
                    <el-option v-for="(bourse, index) in bourseList.bourse" :key="index" :label="bourse" :value="index"></el-option>
                </el-select>
                <el-select v-else-if="index == 'b_transaction_type' && judgeNumToType(item) !== true" disabled v-model="configTaskData.b_transaction_type" @change="aTransTypeChange">
                    <el-option v-for="(type, index) in bbourseType" :key="index" :label="type" :value="index"></el-option>
                </el-select>
                <el-select v-else-if="index == 'b_transaction_type' && judgeNumToType(item) == true" v-model="configTaskData.b_transaction_type" @change="aTransTypeChange">
                    <div v-if="taskConfigParam.taskBaseParams['b_bourse'] == 1">
                        <el-option v-for="(type, index) in okexBourseTransaction" :key="index" :label="addBourseStr(type)" :value="typeValueJudge(type, index)"></el-option>
                    </div>
                    <div v-if="taskConfigParam.taskBaseParams['b_bourse'] == 2">
                        <el-option v-for="(type, index) in huobiBourseTransaction" :key="index" :label="addBourseStr(type)" :value="typeValueJudge(type, index)"></el-option>
                    </div>
                </el-select>

                <el-select v-else-if="index == 'currency_type'" disabled v-model="configTaskData.currency_type"> 
                    <el-option v-for="(currencyItem, index) in currencyList" :key="index" :label="currencyItem" :value="index"></el-option>
                </el-select>
            </el-form-item>

            <el-divider v-if="JSON.stringify(taskConfigParam.debitCreditParams) !==  '{}'"><strong>交易和借贷参数</strong></el-divider>
            <el-form-item v-for="(selfParam, index) in newTaskConfigModel.debitCreditParams" :key="index" :label="debitCreditName(index)">
                <el-switch v-if="index == 'is_borrow'" v-model="configTaskData[index]"></el-switch>
                <div v-else-if="index == 'fund_occupy'">
                    <select class="assets-select" v-model="radio">
                        <option :value="1">百分比</option>
                        <option :value="0">金额</option>
                    </select>
                    <input v-model="configTaskData[index]">
                </div>
                <input v-else v-model="configTaskData[index]">
            </el-form-item>

            <el-divider v-if="JSON.stringify(taskConfigParam.strategyParams) !== '{}'"><strong>策略参数</strong></el-divider>

            <div v-if="showFlag">
                <el-form-item v-for="(selfParam, index) in handleStrategyData.other" :key="index" :label="index">
                    <input v-model="configTaskData[index]">
                </el-form-item>
                <div class="strategy-param">
                    <div>
                        <span>本周</span>
                        <el-form-item v-for="(selfParam, index) in handleStrategyData.mdlt" :key="index" :label="index">
                            <input type="text" v-model="configTaskData[index]['CW']">
                        </el-form-item>
                    </div>
                    <div>
                        <span>次周</span>
                        <el-form-item v-for="(selfParam, index) in handleStrategyData.mdlt" :key="index" :label="index">
                            <input type="text" v-model="configTaskData[index]['NW']">
                        </el-form-item>
                    </div>
                    <div>
                        <span>季度</span>
                        <el-form-item v-for="(selfParam, index) in handleStrategyData.mdlt" :key="index" :label="index">
                            <input type="text" v-model="configTaskData[index]['CQ']">
                        </el-form-item>
                    </div>
                    <div>
                        <span>次季</span>
                        <el-form-item v-for="(selfParam, index) in handleStrategyData.mdlt" :key="index" :label="index">
                            <input type="text" v-model="configTaskData[index]['NQ']">
                        </el-form-item>
                    </div>
                </div>
            </div>

            <div v-else>
                <el-form-item v-for="(selfParam, index) in newTaskConfigModel.strategyParams" :key="index" :label="index">
                    <input v-model="configTaskData[index]">
                </el-form-item>
            </div>
        </el-form>
        <el-divider></el-divider>
        <div class="config-task-footer">
            <el-button v-if="taskData !== 2" @click="submitParam">确认</el-button>
            <el-button @click="dialogVisible.visible = false">取消</el-button>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from 'vuex'
import { post, put, get } from '@/api/index'
import { deepClone } from '@/utils/common'

export default {
    data() {
        return{
            addTaskVisible: true,
            menuKey: 1,
            configTaskData: {},
            currencyList: [],
            transactionTypeList: [2, 3, 4, 7, 8, 9],
            okexBourseTransaction: {2: "本周", 3: "次周", 4: "季度", 10: '次季'},
            huobiBourseTransaction: {7: "本周", 8: "次周", 9: "季度"},
            okexBourseTransaction1: {'本周': 2, "次周": 3, '季度': 4, '次季': 10},
            huobiBourseTransaction1: {'本周': 7, "次周": 8, '季度': 9},
            radio: 1,
            strategyId: '',

            newTaskConfigModel: {},
        }
    },
    props: ['taskData'],
    watch: {
        menuKey: function() {
            console.log('监听调用');
            ++this.menuKey;
        }
    },
    created() {
        this.getTaskParam();
    },
    mounted() {
        // 获取配置参数
        this.strategyParam = this.taskConfigParam;
    },
    computed: {
        ...mapState([
            'bourseList',
            'addTask',
            'strategyList',
            'abourseType',
            'bbourseType',
            'token',
            'dialogVisible',
            'id',
            'taskConfigParam',
            'allTaskIdList',
            'currencyNum',
            'tradeTypeObj'
        ]),
        // 判断策略参数是否显示多行
        showFlag: function () {
            var numList = [];
            for (var i in this.currencyNum) {
                numList.push(this.currencyNum[i]);
            }

            let strategy_name = this.getStrategyName(this.strategyId);
            if (strategy_name.includes('套利2')) {// 当策略名字以套利2开头， 才3分段
                if (this.configTaskData.hasOwnProperty('a_transaction_type') || this.configTaskData.hasOwnProperty('b_transaction_type')) {
                    var a_transaction_type = this.configTaskData['a_transaction_type'];
                    var b_transaction_type = this.configTaskData['b_transaction_type'];
                    var filter_list = ['6', '1', '5'];
                    
                    if (!filter_list.includes(String(a_transaction_type)) || !filter_list.includes(String(b_transaction_type))) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return false;
            }
        },

        // 策略参数分类
        handleStrategyData: function () {
            if (this.newTaskConfigModel.strategyParams) {
                var clone_param = deepClone(this.newTaskConfigModel.strategyParams);
                delete clone_param['dlt'];
                delete clone_param['m'];

                var strategy_param = {
                    'mdlt': {'dlt': this.newTaskConfigModel.strategyParams['dlt'], 'm': this.newTaskConfigModel.strategyParams['m']},
                    'other': clone_param
                }
                return strategy_param;
            } else {
                return {
                    'mdlt': {},
                    'other': {}
                }
            }
        }
        
    },
    methods: {
        ...mapActions([
            'getBourseList',
            'getaBourseType',
            'getbBourseType',
            'getStrategyList',
            'getStrategyParam',
            'getTaskList'
        ]),

        // 交易所选择事件
        bourseChange(bourseName) {
            if (bourseName == 'a') {
                this.getaBourseType();
            } else {
                this.getbBourseType();
            }
        },

        // 获取交易币种
        getCurrency() {
            var url = this.$baseUrl + '/currencyType/get';

            var param = {
                'token': this.token,
                'aTransactionType': this.changeBourseTpye(this.configTaskData['a_transaction_type']),
                'bTransactionType': this.changeBourseTpye(this.configTaskData.b_transaction_type)
            };
            var strategy_len = Object.keys(this.configTaskData);
            if (strategy_len.length !== 0) {// strategyParam 有值
                if (!this.configTaskData.hasOwnProperty('a_transaction_type')) {// 如果 strategyParam 没有 key=a_transaction_type
                delete param['aTransactionType'];
                }
                if (!this.configTaskData.hasOwnProperty('b_transaction_type')) {// 如果 strategyParam 没有 key=b_transaction_type
                delete param['bTransactionType'];
                }
            }
            get(url, param).then(resp => {
                if (resp.code === 200) {
                    this.currencyList = resp.data;
                } else {
                Vue.prototype.$notify.error({
                    message: resp.info,
                    title: '提示',
                    offset: 100
                })
                }
            })
        },

        // 将交易类型数字串转换为正常数字
        changeBourseTpye(param) {
            var mock_data = this.configTaskData;
            if (String(param).length > 2) {
                // > 1, 表示需要转换
                for (var key in this.currencyNum) {
                    if (this.currencyNum[key] == param){// 相等, 明确需要转换的 key
                        var type_name = this.tradeTypeObj[key];
                        if (Number(mock_data.a_bourse) == 1) {// 判断交易所
                            var data1 = this.okexBourseTransaction1[type_name];
                            return String(data1);
                        } else {
                            return this.huobiBourseTransaction1[type_name];
                        }
                    } 
                }
            } else {
                return param;
            }
        },

        // 获取参数
        getTaskParam(strategyName) {
            this.configTaskData = {};
            for (var i in this.addTask) {
                if (i == 'price_limit') {
                    if (this.addTask[i] == 'no') {
                        this.$set(this.configTaskData, i, '');
                    } else {
                        this.$set(this.configTaskData, i, this.addTask[i]);
                    }
                } else if (this.addTask[i][0] == '{') {// 此时为 策略参数
                    this.$set(this.configTaskData, i, JSON.parse(this.addTask[i]))
                } else {
                    this.$set(this.configTaskData, i, this.addTask[i]);
                }
            }
            var fund_occupy_data = String(this.configTaskData.fund_occupy);
            if (fund_occupy_data.indexOf('%') !== -1) {
                // 如果有 %, 赋值时去掉 %
                var real_data = fund_occupy_data.substring(0, fund_occupy_data.length-1);
                this.$set(this.configTaskData, 'fund_occupy', real_data);
                this.radio = 1
            } else {
                this.$set(this.configTaskData, 'fund_occupy', this.addTask['fund_occupy']);
                this.radio = 0
            }
            this.getBourseList().then(data => {
                for (var i in this.configTaskData) {
                    if (i == 'a_bourse') {
                        this.addTask.a_bourse = this.configTaskData[i];
                        this.getaBourseType();
                    } else if (i == 'b_bourse') {
                        this.addTask.b_bourse = this.configTaskData[i];
                        this.getbBourseType();
                    } else if (i == 'a_transaction_type') {
                        this.addTask.a_transaction_type = this.configTaskData[i];
                    } else if (i == 'b_transaction_type') {
                        this.addTask.b_transaction_type = this.configTaskData[i];
                    }
                }
                this.getCurrency();
            });

            this.getStrategyList().then(data => {
                for (var i=0; i<data.length; i++) {
                    if (data[i].name == strategyName) {
                        this.strategyId = data[i].id;
                    }
                }
                if (this.strategyId) {
                    // 获取配置模板
                    this.getConfigModol()
                }
            })
            this.strategyParam = this.taskConfigParam;
        },

        // 策略选择事件
        strategyChange() {
            this.getStrategyParam();
        },

        // 交易类型选择事件
        aTransTypeChange() {
            this.getCurrency();
        },

        // 提交修改配置
        submitParam() {
            var url =  this.$baseUrl +  '/task/params/update';
            var paramObj = {};
            var strategyList = [];
            if (typeof this.taskConfigParam !== 'undefined') {
                for (var key in this.taskConfigParam.strategyParams) {
                    strategyList.push(key);
                }
            }

            for (var i in this.configTaskData) {
                if (i !== 'taskName' && i !== 'strategySelect') {
                    if (i == 'is_borrow') {
                        if (this.configTaskData[i] == true) {
                            paramObj[i] = true;
                        } else {
                            paramObj[i] = false;
                        }
                    } else if (i == 'price_limit') {
                        if (this.configTaskData['price_limit'] == '' ) {
                            // 为空
                            paramObj['price_limit'] = 'no';
                        } else {
                            paramObj[i] = this.configTaskData[i];
                        }
                    } else if (i == 'a_bourse' || i == 'b_bourse' || i == 'currency_type') {// 值为数字
                        paramObj[i] = Number(this.configTaskData[i]);
                    } else if (i == 'a_transaction_type' || i == 'b_transaction_type') {
                        paramObj[i] = this.configTaskData[i];
                    } else if (strategyList.indexOf(i) !== -1) {// 此时为策略参数，值为 JSON 字符串
                        if (typeof this.configTaskData[i] !== 'object') {
                            paramObj[i] = this.configTaskData[i];
                        } else {
                            paramObj[i] = JSON.stringify(this.configTaskData[i]);
                        }
                    } else {
                        paramObj[i] = this.configTaskData[i];
                    }
                }
            }
            // console.log(paramObj)
            // return;
            if (paramObj.hasOwnProperty('a_transaction_type')) {
                var bourse_type = this.judgeTradeType(paramObj['a_transaction_type']);
                paramObj['a_transaction_type'] = bourse_type;
            }
            if (paramObj.hasOwnProperty('b_transaction_type')) {
                var bourse_type = this.judgeTradeType(paramObj['b_transaction_type']);
                paramObj['b_transaction_type'] = bourse_type;
            }

            if (this.radio == 1) {
                // 输入的值为百分比
                paramObj['fund_occupy'] = this.configTaskData['fund_occupy'] + '%';
            } else if (this.radio == 0) {
                paramObj['fund_occupy'] = String(this.configTaskData['fund_occupy']);
            }

            var param = {
                'token': this.token,
                'taskId': this.id.taskId,
                'params': paramObj
            }

            put(url, JSON.stringify(param)).then(resp => {
                if (resp.code == 200) {
                    this.$notify.info({
                        message: '配置任务成功',
                        title: '提示',
                        offset: 100
                    });
                    // 刷新任务列表
                    this.getTaskList();
                    // 关闭窗口
                    this.dialogVisible.visible = false;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 判断交易类型
        judgeTradeType(param) {
            var data = Number(param);
            if (data == 2 || data == 7) {
                // 本周
                return this.currencyNum['CW'];
            } else if (data == 3 || data == 8) {
                // 次周
                return this.currencyNum['NW'];
            } else if (data == 4 || data == 9) {
                // 季度
                return this.currencyNum['CQ'];
            } else {
                return param;
            }
        },

        // 参数名字判别
        paramJugde(index) {
            if (index == 'a_bourse') return 'A交易所';
            else if (index == 'b_bourse') return 'B交易所';
            else if (index == 'a_transaction_type') return 'A交易类型';
            else if (index == 'b_transaction_type') return 'B交易类型';
            else if ( index == 'currency_type') return '币种';
            return index;
        },

        // 借贷参数名判断
        debitCreditName(name) {
            if (name == 'fund_occupy') return '资金可占用比';
            else if (name == 'is_borrow') return '是否允许可借贷';
            else if (name == 'virtual_initial_capital') return '任务虚拟初始资金';
            else if (name == 'slip') return '滑点';
            else if (name == 'depth') return '价格深度';
            else if (name == 'price_limit') return '价格控制';
            return name;
        },

        // 交易类型名称拼接
        addBourseStr(name) {
            if (name == '本周') return this.currencyNum['CW'] + '-' +name;
            else if (name == '次周') return this.currencyNum['NW'] + '-' +name;
            else if (name == '季度') return this.currencyNum['CQ'] + '-' +name;
            else if (name == '次季') return this.currencyNum['NQ'] + '-' +name;
        },

        // 交易转换为数字
        typeValueJudge(name, index) {
            if (name == '本周') return this.currencyNum['CW'];
            else if (name == '次周') return this.currencyNum['NW'];
            else if (name == '季度') return this.currencyNum['CQ'];
            else if (name == '次季') return this.currencyNum['NQ'];
            return name;
        },

        // 根据数字判断交易类型是否可以选择
        judgeNumToType(type) {
            // var type = '191108';
            var flag = true;
            var filter_list = ['6', '1', '5'];
            if (filter_list.includes(String(type))) {
                flag = false;
            }
            return flag;
        },

        // 获取配置模板
        getConfigModol() {
            let url = this.$baseUrl + '/strategy/params/get';
            let param = {
                'token': this.token,
                'strategyId': this.strategyId
            };
            
            get(url, param).then(resp => {
                if (resp.code == 200) {
                    let data = resp.data;
                    this.newTaskConfigModel = data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                }
            })
        },

        // 获取 策略参数
        getStrategyName(strategyId) {
            for (let i in this.strategyList) {
                let stategy = this.strategyList[i];
                if (strategyId == Number(stategy.id)) {
                    // id 相等
                    return stategy.name;
                }
            }
            return '';
        }
    }
}
</script>

<style lang="scss">
    .config-task-dialog{
        .config-task-title{
            // background-color: #000;
            padding: 15px 15px 5px 15px;
            h3{
                text-align: center !important;
                font-size: 23px;
            }
        }
        .el-divider{
            margin: 12px 0;
        }
        .el-form{
            width: 75%;
            margin: 0 auto;
            padding: 10px 20px;
            .strategy-param{
                display: flex;
                justify-content: flex-start;
                div{
                    .el-form-item{
                        .el-form-item__label{
                            width: 50px !important;
                        }
                        .el-form-item__content{
                            margin-left: 50px !important;
                        }
                    }
                }
            }
            .el-form-item{
                .el-select{
                    display: flex;
                }
                input{
                    padding: 8px 3px;
                    width: 100%;
                    outline: 0;
                    font-size: 13px;
                    border: 1px solid #DCDFE6;
                    border-radius: 4px;


                }
                .el-form-item__content{
                    text-align: left;
                    .el-input__inner{
                        font-size: 13px;
                    }
                    .assets-select{
                        padding: 4px 5px;
                        border-color: #DCDFE6;
                        font-size: 12px;
                        border-radius: 3px;
                    }
                }
            }
        }
        .config-task-footer{
            padding: 0 10px 15px 10px;
            text-align: right;
            .el-button{
                padding: 10px 20px !important;
                background-color: #fff;
            }
        }
    }

    @media screen and (max-width: 380px) {
        .config-task-dialog{
            .el-form{
                .el-form-item{
                    input{
                        padding: 8px 0 8px 0px !important;
                    }
                }
            }
        }
    }
</style>
